import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const UpMove = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb488__a">
              <rect
                rx="0"
                height="48"
                width="48"
                x="48"
              />
            </clipPath>
          </defs>
          <g
            clipPath="url(#bb488__a)"
            transform="matrix(-1 0 0 1 96 0)"
            style={{ mixBlendMode: 'passthrough' }}
          >
            <path
              fillRule="evenodd"
              d="M63.273 63H70V44.985C70 43.88 70.91 43 72.015 43h.033c1.105 0 1.952.88 1.952 1.985V63h6.727c.87 0 1.325 1.034.737 1.676l-8.727 9.52a1 1 0 0 1-1.474 0l-8.727-9.52c-.588-.642-.133-1.676.737-1.676ZM53 78.952v.033C53 80.09 53.887 81 54.992 81h34.016C90.113 81 91 80.153 91 79.048v-.033C91 77.91 90.113 77 89.008 77H54.992C53.887 77 53 77.847 53 78.952"
              transform="matrix(1 0 0 -1 0 86)"
              style={{ mixBlendMode: 'passthrough' }}
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
